/**
 * AUTOGENERATED, DO NOT EDIT!
 *
 * https://gitlab.com/digital-pharma-tools/open-api-codegen
 *
 * Generated: Fri, 09 Jun 2023 12:38:24 +0000
 */
export enum DpModuleEnum {
    AUTH = 'AUTH',
    BOH = 'BOH',
    CMS = 'CMS',
    CPC = 'CPC',
    IDM = 'IDM',
    KIOSK = 'KIOSK',
    MASTER = 'MASTER',
    MON = 'MON',
    ORDER = 'ORDER',
    PAY = 'PAY',
    PIM = 'PIM',
    PP3 = 'PP3',
    SMA = 'SMA',
    TP = 'TP',
    PLAN = 'PLAN',
}
